"use client";

import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useState } from "react";
import Toast from "../../(components)/Toast";
import { useYupValidationResolver } from "../(utils)/useYupValidationResolver";
import { validationSchema } from "./(utils)/validationSchema";
import { Form } from "./(components)/Form";
import { FrameBody } from "../(components)/FrameBody";
import { useTranslation } from "../../../i18n/client";
import axiosInstance from "../../../../utils/axios";

const PasswordRecovery = ({ params }: any) => {
  const { lng } = params;
  const { t }: { t: any } = useTranslation(lng, "auth");
  const [serverError, setServerError] = useState("");

  const resolver = useYupValidationResolver(validationSchema);
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting, submitCount, isValid },
  } = useForm({ resolver });

  const PostPasswordRecovery = async (data: any) => {
    return axiosInstance.post("api/transporter/auth/forgot-password", data, {
      headers: {
        "Accept-Language": `${
          lng === "en"
            ? "en-US,en;q=0.9,uk-UA;q=0.8,uk;q=0.7"
            : "de-DE,de;q=0.9,en-US;q=0.8,en;q=0.7"
        } `,
      },
    });
  };

  const { mutate } = useMutation({
    mutationFn: PostPasswordRecovery,
    onSuccess: () => {},
    onError: (error: any) => {
      setServerError(`${error.response.data.message}`);
      toast.error(`${error.response.data.message}`);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    },
  });

  const onSubmit = async (data: any) => {
    const formData: any = new FormData();
    formData.append("email", data?.email);
    mutate(formData);
  };


  return (
    <>
      <Toast />
      <FrameBody mainText={t("pass_recovery_form")} t={t}>
        <p className="text-[14px] text-md-[16px] text-[#031F47] mb-6">
          {t("registered_email_form")}
        </p>
        <Form
          t={t}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          errors={errors}
          register={register}
          isSubmitting={isSubmitting}
          submitCount={submitCount}
          isValid={isValid}
          serverError={serverError}
        />
      </FrameBody>
    </>
  );
};

export default PasswordRecovery;
